import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Badge, Box, Button, Card, CardContent, Grid, Tab, Tabs } from '@mui/material'

import { useFetchInitTransactionBank } from './hooks'
import { TableTransactionBank } from './TableTransactionBank'
import { FilterForm } from './FilterForm'
import { FormTransactionBank } from './FormTransactionBank'
import { FilterMovements } from './FilterMovements'
import { TableMovements } from './TableMovements'
import { FormMovementBank } from './FormMovementBank'
import { ModalModule } from './ModalModule'

const tabsSx = {
    minHeight: 0,
    backgroundColor: '#f1f1f1',
    borderRadius: '999px',
    padding: '4px',
    '& .MuiTabs-indicator': { display: 'none' },
    '& .MuiTab-root': {
        minHeight: 0,
        padding: '8px 22px',
        borderRadius: '999px',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.95rem',
        color: '#4b4b4c',
        transition: 'background-color .2s ease, color .2s ease, box-shadow .2s ease',
        '&:hover': { backgroundColor: 'rgba(75, 75, 76, 0.08)' },
    },
    '& .MuiTab-root.Mui-selected': {
        backgroundColor: '#4b4b4c',
        color: '#fff',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
    },
}

export const TransactionBank = () => {

    const location = useLocation()
    const paramsURL = useParams()
    const useFetchInit = useFetchInitTransactionBank({ location, paramsURL })

    const { showForm, activeTab, showMovementForm } = useFetchInit.globalStates
    const { dataBankDeposits } = useFetchInit.FetchData.fetchBankDeposits
    const pendingDeposits = dataBankDeposits.filter(d => d.aprobacion_check === 'PENDIENTE').length
    const { handleChangeTab, handleClickOpenMovementForm } = useFetchInit.Actions

    return (
        <AllowedAccess permissions={['242_MOVIMIENTO_DE_BANCOS']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            <div className="content">
                <div className="panel-body">
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Card style={{ zIndex: '1' }}>
                                <CardContent>

                                    <div className='h4 mt-1 mb-1'>Bancos: Transacciones</div>
                                    <div className="border-bottom border-dark"></div>

                                    {/* Las pestañas se ocultan mientras hay un formulario abierto */}
                                    {!showForm && !showMovementForm && (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: 3 }}>
                                            <Tabs value={activeTab} onChange={handleChangeTab} centered sx={tabsSx}>
                                                <Tab
                                                    value='MOVIMIENTOS'
                                                    disableRipple
                                                    icon={<i className="fa-solid fa-right-left"></i>}
                                                    iconPosition='start'
                                                    label='Movimientos'
                                                />
                                                <Tab
                                                    value='DEPOSITOS'
                                                    disableRipple
                                                    icon={<i className="fa-solid fa-file-circle-check"></i>}
                                                    iconPosition='start'
                                                    label={
                                                        <Badge
                                                            badgeContent={pendingDeposits}
                                                            color='warning'
                                                            max={999}
                                                            sx={{ '& .MuiBadge-badge': { right: -18, top: 2 } }}
                                                        >
                                                            Depósitos por aprobar
                                                        </Badge>
                                                    }
                                                    sx={{ paddingRight: '34px !important' }}
                                                />
                                            </Tabs>
                                        </Box>
                                    )}

                                    {/* ------------------- Pestaña: Movimientos ------------------- */}
                                    {activeTab === 'MOVIMIENTOS' && !showMovementForm && (
                                        <>
                                            <div className="d-flex justify-content-end pt-4">
                                                <Button
                                                    style={{ background: '#4b4b4c' }}
                                                    variant="contained"
                                                    type="button"
                                                    onClick={handleClickOpenMovementForm}
                                                >
                                                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                                </Button>
                                            </div>
                                            <div className="pt-4"></div>
                                            <FilterMovements useFetchInit={useFetchInit} />
                                            <div className="pt-4"></div>
                                            <TableMovements useFetchInit={useFetchInit} />
                                        </>
                                    )}

                                    {activeTab === 'MOVIMIENTOS' && showMovementForm && (
                                        <>
                                            <div className="pt-4"></div>
                                            <FormMovementBank useFetchInit={useFetchInit} />
                                        </>
                                    )}

                                    {/* ------------------- Pestaña: Depósitos por aprobar ------------------- */}
                                    {activeTab === 'DEPOSITOS' && !showForm && (
                                        <>
                                            <div className="pt-4"></div>
                                            <FilterForm useFetchInit={useFetchInit} />
                                            <div className="pt-4"></div>
                                            <TableTransactionBank useFetchInit={useFetchInit} />
                                        </>
                                    )}

                                    {activeTab === 'DEPOSITOS' && showForm && (
                                        <>
                                            <div className="pt-4"></div>
                                            <FormTransactionBank useFetchInit={useFetchInit} />
                                        </>
                                    )}

                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </AllowedAccess>
    )
}
